<template>
  <div class="container">
    <JumpHeader />
    <div class="publish-img">
      <img src="~@/assets/image/publish_detail_bg.png" alt="" />
    </div>
    <div class="account-info">
      <div class="identity">
        <van-image
          class="avatar"
          width="100px"
          height="100px"
          fit="contain"
          round
          :src="publishInfo.logo"
        />
      </div>
      <div class="num-wrapper">
        <div class="num-item">
          <span class="num-name">发布资讯</span>
          <span class="num">{{ numFilter(countData.newsCount) }}</span>
        </div>
        <div class="num-item">
          <span class="num-name">关注</span>
          <span class="num">{{ numFilter(countData.careCount) }}</span>
        </div>
        <div class="num-item">
          <span class="num-name">获赞</span>
          <span class="num">{{ numFilter(countData.praiseCount) }}</span>
        </div>
      </div>
    </div>
    <div class="publish-name">
      <div class="name">
        {{ publishInfo.name }}
      </div>
      <div class="follow" @click="downLoadToast">关注</div>
    </div>
    <div class="verify">
      <img src="~@/assets/image/verify.png" alt="" />
      <span> 广州市广播电视台认证账号 </span>
    </div>
    <div class="intro">
      {{ publishInfo.intro ? publishInfo.intro : "作品主要是作者对文学创作的一些看法" }}
    </div>
    <div class="content">
      <van-tabs line-height="3px" line-width="70px" v-model="tabsActive" animated>
        <van-tab :title="`文章${numFilter(countData.newsCount)}`">
          <van-list
            class="article-list"
            v-model="articleLoad.loading"
            :finished="articleLoad.finished"
            finished-text="已经到底了"
            @load="articleOnLoad"
          >
            <div
              class="article-item"
              v-for="item in articleList"
              :key="item.id"
              @click="toArticleDetail(item)"
            >
              <div class="left">
                <div class="title">{{ item.title }}</div>
                <div class="from">
                  {{ item.from ? item.from : "花城+" }}
                </div>
              </div>
              <div class="right">
                <img :src="item.coverPictureUrl.split(',')[0]" />
              </div>
            </div>
          </van-list>
        </van-tab>
        <van-tab :title="`视频${numFilter(countData.videoCount)}`">
          <van-list
            class="video-list"
            v-model="videoLoad.loading"
            :finished="videoLoad.finished"
            finished-text="已经到底了"
            @load="videoOnLoad"
          >
            <VideoItem
              class="video-item"
              :item="item"
              v-for="item in videoList"
              :key="item.id"
              @click.native="toVideoDetail(item)"
            />
          </van-list>
        </van-tab>
        <van-tab :title="`直播${numFilter(countData.liveRoomCount)}`">
          <van-list
            class="living-list"
            v-model="livingLoad.loading"
            :finished="livingLoad.finished"
            finished-text="已经到底了"
            @load="livingOnLoad"
          >
            <LivingItem
              class="living-item"
              :item="item"
              v-for="item in livingList"
              :key="item.id"
              @click.native="toLiveDetail(item)"
            />
          </van-list>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script>
import wxSdk from "@/http/wxApi.js";
import { Toast } from "vant";
import VideoItem from "@/components/VideoItem";
import LivingItem from "@/components/LivingItem";
import ArticleItem from "@/components/ArticleItem";
import JumpHeader from "@/components/Base/JumpHeader";
import { getCount, getVideo, queryPublishArticles, getLiveRoom } from "@/http/api";

export default {
  name: "AccountDetail",
  components: {
    VideoItem,
    ArticleItem,
    LivingItem,
    JumpHeader,
  },
  data() {
    return {
      countData: {
        videoCount: 0,
        careCount: 0,
        praiseCount: 0,
        liveRoomCount: 0,
        newsCount: 0,
      },
      publishInfo: {},
      id: null,
      articleList: [],
      videoList: [],
      livingList: [],
      articleLoad: {
        loading: false,
        finished: false,
        pageNumber: 1,
      },
      videoLoad: {
        loading: false,
        finished: false,
        pageNum: 1,
      },
      livingLoad: {
        loading: false,
        finished: false,
        pageNum: 1,
      },
      tabsActive: 0,
    };
  },
  mounted() {
    this.id = this.$route.query.id;
    this.getDetail();
    this.getArticleList();
    this.getVideoList();
  },
  methods: {
    downLoadToast() {
      Toast.fail("请先下载app");
    },
    numFilter(num) {
      if (num && num > 10000) {
        return `${(num / 10000).toFixed(2)}w`;
      }
      return num;
    },

    async getDetail() {
      const { data } = await getCount({
        id: this.id,
      });
      this.countData = {
        careCount: data.careCount,
        liveRoomCount: data.liveRoomCount,
        newsCount: data.newsCount,
        praiseCount: data.praiseCount,
        videoCount: data.videoCount,
      };
      this.publishInfo = data.publishInfo;
      document.title = this.publishInfo.name ? this.publishInfo.name : "花城+";
      this.$nextTick(() => {
        this.wxShare();
      });
    },

    async getArticleList() {
      this.articleLoad.loading = true;
      const { data } = await queryPublishArticles({
        pageNumber: this.articleLoad.pageNumber,
        pageSize: 10,
        params: {
          huaChengId: this.id,
        },
      });

      this.articleLoad.loading = false;
      if (this.articleLoad.pageNumber >= 10) {
        this.articleLoad.finished = true;
      }
      this.articleList = [...this.articleList, ...data.records];
    },
    async getVideoList() {
      this.videoLoad.loading = true;
      const { data } = await getVideo({
        publishId: this.id,
        pageNum: this.videoLoad.pageNum,
        pageSize: 9,
      });
      this.videoLoad.loading = false;
      if (this.videoLoad.pageNum >= data.pages) {
        this.videoLoad.finished = true;
      }
      this.videoList = [...this.videoList, ...data.records];
    },
    async getLivingList() {
      this.livingLoad.loading = true;
      const { data } = await getLiveRoom({
        publishId: this.id,
        pageNum: this.livingLoad.pageNum,
        pageSize: 10,
      });
      this.livingLoad.loading = false;
      if (this.livingLoad.pageNum >= 5) {
        this.livingLoad.finished = true;
      }
      this.livingList = [...this.livingList, ...data.records];
    },

    articleOnLoad() {
      this.articleLoad.pageNumber++;
      this.getArticleList();
    },
    videoOnLoad() {
      this.videoLoad.pageNum++;
      this.getVideoList();
    },
    livingOnLoad() {
      this.livingLoad.pageNum++;
      this.getLivingList();
    },

    toArticleDetail(item) {
      this.$router.push({
        name: "articleDetail",
        query: {
          id: item.manuId,
        },
      });
    },
    toVideoDetail(item) {
      this.$router.push({
        name: "videoDetail",
        query: {
          id: item.id,
        },
      });
    },
    toLiveDetail(item) {
      this.$router.push({
        name: "liveDetail",
        query: {
          id: item.id,
        },
      });
    },

    wxShare() {
      const _publishInfo = this.publishInfo;
      wxSdk.getJSSDK({
        title: _publishInfo.name,
        desc: _publishInfo.intro ? _publishInfo.intro : _publishInfo.name,
        linkurl: `${process.env.VUE_APP_SHARE_URL}/plusshare/#/accountDetail?id=${_publishInfo.paramValue}`,
        img: _publishInfo.logo,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/index.scss";

.container {
  display: flex;
  flex-direction: column;
  width: 100%;
  .publish-img {
    width: 100%;
    height: 180px;

    & > img {
      width: 100%;
      height: 100%;
    }
  }

  .account-info {
    display: flex;
    justify-content: space-between;
    position: relative;
    .identity {
      display: flex;
      flex-direction: column;
      align-content: center;
      .avatar {
        position: absolute;
        left: 15px;
        transform: translateY(-50%);
        z-index: 1;
      }
    }

    .num-wrapper {
      display: flex;
      padding-right: 5px;
      padding-top: 5px;
      .num-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 70px;
        height: 60px;
        .num-name {
          display: inline-block;
          color: #00000073;
          font-size: 12px;
          margin-bottom: 3px;
        }
        .num {
          font-size: 16px;
        }
      }
    }
  }
  .publish-name {
    display: flex;
    justify-content: space-between;
    .name {
      font-size: 18px;
      margin-left: 15px;
    }
    .follow {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 50px;
      height: 20px;
      font-size: 12px;
      margin-right: 10px;
      color: #d55555;
      border-radius: 10px;
      border: 1px solid #d55555;
    }
  }

  .verify {
    display: flex;
    align-items: center;
    box-sizing: border-box;
    padding: 0 15px;
    margin-top: 5px;

    & > img {
      width: 16px;
      height: 16px;
      margin-right: 5px;
    }

    & > span {
      font-size: 12px;
      color: #00000073;
    }
  }

  .intro {
    display: flex;
    align-items: center;
    margin-top: 5px;
    margin-left: 15px;
    font-size: 12px;
    box-sizing: border-box;
    color: #00000097;
  }

  .content {
    .article-list {
      .article-item {
        display: flex;
        justify-content: space-between;
        margin: 5px 15px 14px;
        .left {
          margin-right: 15px;
          .title {
            font-size: 18px;
            color: #000000;
            height: 51px;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .from {
            font-size: 14px;
            color: #00000073;
            height: 19px;
            margin-left: 8px;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
        .right {
          img {
            width: 120px;
            height: 70px;
            object-fit: cover;
            border-radius: 4px;
          }
        }
      }
    }

    .video-list {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      padding: 5px 0 0;
      .video-item {
        width: 33%;
        margin-right: 0.5%;
        &:nth-child(3n) {
          margin-right: 0;
        }
      }
    }

    .living-list {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 5px 0 0;
      .living-item {
        width: 100%;
      }
    }
  }
}
</style>
